import { IconProps } from "./IconProps";

export const CheckmarkIcon = ({ height = 64, width = 64, color = "#88A926" }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_checkmark_icon)">
            <path
                d="M43.4613 22.1013L47.2053 25.9013L31.7573 41.12C30.7253 42.152 29.368 42.6667 28.0053 42.6667C26.6427 42.6667 25.272 42.1467 24.2293 41.1067L16.8107 33.9173L20.5253 30.0853L27.9733 37.304L43.4613 22.1013ZM64 32C64 49.6453 49.6453 64 32 64C14.3547 64 0 49.6453 0 32C0 14.3547 14.3547 0 32 0C49.6453 0 64 14.3547 64 32ZM58.6667 32C58.6667 17.296 46.704 5.33333 32 5.33333C17.296 5.33333 5.33333 17.296 5.33333 32C5.33333 46.704 17.296 58.6667 32 58.6667C46.704 58.6667 58.6667 46.704 58.6667 32Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_checkmark_icon">
                <rect width="64" height="64" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
